import React from "react";
import Propulator from "higher-order/Propulator";
import PropTypes from "prop-types";

export class ContentItemLiteral extends React.Component {
    static propTypes = {
        contentKey: PropTypes.string.isRequired,
        sharedKey: PropTypes.string,
        stringFormatArgs: PropTypes.object
    };

    render() {
        const {
            extractContent,
            contentKey,
            sharedKey,
            stringFormatArgs
        } = this.props;
        return (<React.Fragment>{extractContent(contentKey, sharedKey, stringFormatArgs)}</React.Fragment>);
    }
}

export default Propulator(ContentItemLiteral, {
    contentStore: ["extractContent"]
});